import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback, useEffect, useState } from 'react';
import { createChangeSettingOutbound } from '../../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../../redux/store';
import { PLAYER_SERVER_SETTING_PROPERTIES } from '../../../types/playerServerSettingsTypes';
export const ServerSettingItemButton = ({ settingType }) => {
    const [isChangePending, setIsChangePending] = useState(false);
    const socketSend = useSocketSend();
    const settingLabel = useAppSelector((state) => state.selfData.playerServerSettingLabels[settingType]);
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClick = useCallback(() => {
        setIsChangePending(true);
        socketSend(createChangeSettingOutbound(settingType));
    }, [settingType, socketSend]);
    useEffect(() => {
        setIsChangePending(false);
    }, [settingLabel]);
    if (!settingLabel) {
        return null;
    }
    const { isPowerPlayerOnly, name } = PLAYER_SERVER_SETTING_PROPERTIES[settingType];
    const isPowerPlayerRestricted = isPowerPlayerOnly && !isPowerPlayer;
    return (_jsx(Button, { color: settingLabel.toLocaleLowerCase() === 'off' ? 'secondary' : 'primary', variant: 'contained', disabled: isPowerPlayerRestricted || isChangePending, onClick: onClick, "aria-label": `${name}: ${settingLabel}`, children: settingLabel }));
};
